import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SensorsOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sensors_off"}/>
}
